<template>
    <menu_orders_switch
        v-if="isMobileScreen && isStartChoiceRest"
        :key="'menu_orders_switch'"
        @click_switch_button="clickSwitchButton"
    />
    <div v-if="isMobileScreen && isStartChoiceRest" class="menu_orders__list_no_orders">
        {{ __t('O.YOU_DONT_HAVE_ORDERS') }}
    </div>

    <start_choice_rest
        v-if="isStartChoiceRest"
        :key="'start_choice_rest'"
    />
    <rest_select_list
        v-if="!isLoadList"
        :key="'rest_select_list'"
        :operationName="'select_rest'"
        :onlySelectLocations="false"
    />
</template>

<script>

import menu_orders from "../../menu/order/MenuOrders.vue";
import rest_select_list from "../RestSelectList.vue";
import {createHelpers} from "vuex-map-fields";
import start_choice_rest from "../StartChoiceRest.vue";
import loader_page from "../../loader/LoaderPage.vue";
import {screenSize} from "../../../mixins/screenSize";
import menu_orders_switch from "../../menu/order/MenuOrdersSwitch.vue";

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})

export default {
    name: "rest_select_page",
    emits: [],
    components: {
        menu_orders_switch,
        loader_page,
        start_choice_rest,
        menu_orders,
        rest_select_list,
    },
    mixins: [screenSize],
    data() {
        return {
            statusModal: false,
            isLoadList: true,
            showOrdersMenu: false,
            searchData: '',
            isStartChoiceRest: false,
        }
    },
    beforeMount() {
        this.$store.dispatch('user/STATE_LOAD_PAGE', true);
        this.$store.dispatch('aggregators/GET_ALL_SELECT_LOCATIONS_COUNT', {actionName: 'getAllSelectLocationsCount'});
        EventBus.$on('active_aggregators_list', this.loadList);
        EventBus.$on('select_locations_count', this.loadSelectLocationsCount);
        EventBus.$on('active_aggregators_delivery_list', this.loadList);
        EventBus.$on('click_select_rest', this.clickSelectRest);
        EventBus.$on('error_data', this.errorData);
    },
    beforeUnmount() {
        EventBus.$off('active_aggregators_list', this.loadList);
        EventBus.$off('select_locations_count', this.loadSelectLocationsCount);
        EventBus.$off('active_aggregators_delivery_list', this.loadList);
        EventBus.$off('click_select_rest', this.clickSelectRest);
        EventBus.$off('error_data', this.errorData);
    },
    methods: {
        errorData(actionName) {
            if (actionName === 'activeAggregatorsList' || actionName === 'activeAggregatorsDeliveriesList') {
                this.isLoadList = false;
            }
        },
        loadSelectLocationsCount(){
            this.$store.dispatch('user/STATE_LOAD_PAGE', false);
            if (this.countAllSelectLocations === 0) {
                this.isStartChoiceRest = true;
                this.showOrdersMenu = true;
                return;
            }
            this.clickSelectRest();
            //EventBus.$emit('get_state_menu_main');
        },
        loadList() {
            this.isLoadList = false;
        },
        clickSelectRest() {
            this.menuMainItems.forEach(item => item.isSelect = item.name === 'select_rest');
            this.isStartChoiceRest = false;
            this.isLoadList = true;
            this.$store.dispatch('aggregators/ACTIVE_AGGREGATORS_DELIVERIES_LIST',  {
                user: this.user,
                actionName: 'getActiveAggregatorsDeliveries',
                onlySelectLocations: false
            });
        },
        clickSwitchButton(activeOrdersSwitch) {
            if (activeOrdersSwitch) {
                this.isActiveSwitch = true;
                return;
            }
            this.isActiveSwitch = false;
        },
    },
    computed: {
        ...mUser([
            'user',
            'menuMainItems',
            'errorMessageLogin',
            'isLoadPage',
        ]),
        ...mAggregators([
            'countAllSelectLocations',
            'aggregatorsDeliveriesList',
            'isLoadActiveAggregatorsList',
            'isLoadLocationsAggregator'
        ]),
        ...mCouriers([
            'isLoadLocationsDelivery',
        ]),
    },
}
</script>
